import React from 'react';
import PropTypes from 'prop-types';
import { connectToJSContext, RA_73_STERILIZE_HTML_STRING } from '../utils.jsx';
import { aboutMeBioBody, aboutMeBioHeader } from './selectors';

const AboutMeBio = props => (
    <div className="container about-me-bio">
        <div className="row">
            <div className="col-xs-12">
                <div className="about-me-bio__header page-header">
                    <p
                        dangerouslySetInnerHTML={{
                            __html: RA_73_STERILIZE_HTML_STRING(props.aboutMeHeader)
                        }}
                    />
                </div>
                <p
                    className="about-me-bio__text"
                    dangerouslySetInnerHTML={{
                        __html: RA_73_STERILIZE_HTML_STRING(props.aboutMeBioText)
                    }}
                />
            </div>
        </div>
    </div>
);

AboutMeBio.propTypes = {
    aboutMeHeader: PropTypes.string.isRequired,
    aboutMeBioText: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    aboutMeHeader: aboutMeBioHeader(state),
    aboutMeBioText: aboutMeBioBody(state)
});

export default connectToJSContext(mapStateToProps)(AboutMeBio);



// WEBPACK FOOTER //
// ./components/aboutmebio/index.jsx